import { Component } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-destructor',
  templateUrl: './destructor.component.html',
  styleUrls: ['./destructor.component.scss']
})
export class DestructorComponent {

  public subscriptions: Subscription[] = [];

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    console.log('Destructor');

    this.subscriptions.map(subs => { subs.unsubscribe(); })
  }

}
